module.exports = __webpack_public_path__ + "img/endo.0910b970.jpg";